export default {
    Zones: {
        ZonesList: [],
        ClientSideZonesData: {}
    },

    TenantEmployee: {
        EmployeeList:[],
        RegularExpression:[],
        ClientSideEmployeesData:{}
    },
    
    TenantServices: {
        TenantsList: [],
        licensed: 0,
        TenantNameList: []
    },

    Requests: {
        requestsList: [],
    },

    ViewtenantDetails: {
        TenantDetails: [],
        CompanyInformation: [],
        Zones: [],
        AfterHours: [],
        HoursofOperation: [],
        Employees: [],
        UsageMeters: [],
        FixedCharges: [],
        ModalAddHoursPeriod: {},
    },



    userdetails: {
        loggedIn: false,
        token: null,
        user_type: null,
        invalid_user: false,
        user_details_complete_data:null,
        TenantUserContext: null,
        password_expired:false,
        password_used_in_history:false,
        user_forbidden:false,
        singleSignOn_login_url:null,
        API_not_responding:false,
        EULA: false,
        userdetails:null,
        userTransaction:0,
        workorder_user_preferencedetails:[],
        preventative_maintenance_user_preferencedetails:[]
    },

    facility: {
        loginlogo: null,
        places: null,
        requests: [],
        TenantUserContext: [],
        facilityzonedetails: null,
        TempWidgetDetails: null,
        EmployeeTenantOrigin: false,
    },

   
    
    responseTest: {
        get: null,
        post: null
    },
    
    manangeTenants: {
    },
    // Viewtenant: {
    //     TenantDetails: []
    // },
    

    Tenants: {
        TenantsList: [],
        HoursofOperation: [],
        TenantToDisplay: { userID: 0},
        TenantsForInvoice: {usersIDs: []},
        userDetails : {},
        EmployeeDetails : {},
        ClientSideComapnyData : {},
        Cost:{},
        TenantNameList: []
    },


    MeterValue: {
        MeterValueList: []
    },

    Buildings: {
        BuildingsList: []
    },

    Members: {
        MembersList: []
    },
    
 Holidays: {
        HolidayList: []
    },

    BuildingDetails: {
        BuildingsDetailsList: []
    },

    FamilyDetails: {
        FamilyDetailsList: []
    },

    EquipmentObjectDetails: {
        EquipmentObjectDetailsList: []
    },

    BuildingPointsDetails: {
        BuildingPointsDetailsList: []
    },

    BuildingEquipmentPointsDetails: {
        BuildingEquipmentPointsDetailsList: []
    },

    BuildingUnitsDetails: {
        BuildingUnitsDetailsList: []
    },

    BuildingDatalogObjectsDetails: {
        BuildingDatalogObjectDetailsList: []
    },

    Holiday: {
        HolidayDts: []
    },
    //User perference
    Preference: {
        UserPreference: {}
    },

    CulturalLabels: {
         LabelsBasedOnPreference: {},
         SystemAdmin_LabelsBasedOnPreference: {},
         DMResource_LabelsBasedOnPreference: {},
         WorkOrderResource_LabelsBasedOnPreference: {},
         DataVis_LabelsBasedOnPreference: {},
         ReportMgmt_LabelsBasedOnPreference: {},
         Status_LabelsBasedOnPreference: {}
    },

    UserDetails: {
        user_info: {},
   },

    CommonResources: {
        CommonResourcesData: null,
   },

    TenantId:{ TenantId:0 },
 

    //Modal open close state
    ModalState: {   ModalOpenClose: {} },
    ModalAddHoursPeriod: {   AddHoursPeriodModal: {} },


    IsValidTenantName: {
        IsValidTenantName: false
    },

    Request:{
        AllRequests:[],
        SelectedRequest:[],
        RequestId:0,
        Zone_TimeZone:null
    },


    FacilityDisplay: {   FacilityDisplay: "Home" },

    TemperatureAdjustments: {
        TempAdjustmentsList: [],
    },

    InvoiceDetail:{
        TenantInvoiceDetails:[],
        TenantAfterHourDetails:[],
        InvoiceTemplate:[],
        Invoicelogo:null,
        PostInvoiceLogo:[],
        GeneratedInvoiceList:[]
    },

    FacilityImageDetail:[],
    FacilityImage:null,
    // Administration

    Administartion: {
        Installations: [],
        BuildingsDiscovered: null,
        AddNewBuildings:null,
        ServerId:0,
        License:[],
        CustomerInformation:[],
        UploadStatus:false,
        UploadLicenseFileResponse:{},
        UserRoles: [],
        UserLists: [],
        UserDeatils: [],
        ApplicationVersion: '',
        Productfullversion:'',
        Dbversion:'',
        BuildingList:[],
        TenantWorkOrderLicense:[],
        BuildingsTimeZones:[],
        ResetPasswordErrorMsg: '',
        IsCloud:false,
        DevicePanelDetails:[],
    },

    // HubManagement

    HubManagement:{
        GetExternalHubUri:[],
        GetNetworkList:[],
        certificateList:[],
    },

    //Workorder
    Workorder:{
        Workorderlist:[],
        WorkorderBuildings:[],
        BuildingsEquipments:[],
        PMBuildingsEquipments:[],
        WorkorderEquipments:[],
        WorkOrderDetails:[],
        Technicians:[],
        TechnicianDetails: [],
        WorkOrderBuildingDisplay: {   page_to_display_building: "BuildingList" },
        WorkOrderTenantDisplay: { page_to_display_tenant: "TenantList" },
        WorkOrderStandardFields:[],
        TenantToAssociate: { tenant_to_associate: 0 },
        TenantAssociations: [],
        PreventativeMaintenanceList:[],
        PreventativeMaintenanceStandardFields:[],
        BuildingFamilyTypes:[],
        UsageBuildingFamilyTypes:[],
        BuildingEquipmentsByFamilyType:[],
        UsageBuildingEquipmentsByFamilyType:[],
        BuildingPoints:[],
        BuildingEquipmentPoints:[],
        DiscoverdBuildings:[],
        ServerTime:'',
        MailSetting: false,
        WorkOrderCustomFields:[],
        AddCutomModalOpenClose: { modal_open: false },
        PreventativeMaintenanceCustomFields:[],
        UniqueAttachmentName: [],
        UniqueAttachmentCollection: [],
        ServiceRequestSetUpDetails: [],
        WorkOrderFormCustomFields: [],
        WorkOrderFormTenantLists: [],
    },

    workorder_user_preferencedetails: [],
    preventative_maintenance_user_preferencedetails:[],
    
    //Reports Mangement
    Reports: {
        MangeReportslist: [],
        MangeReportsSublist: [],
        RunReport_status: null
    },

    // Data Export and Schedules
    DataExport: {
        DatalogDefinitions: [],
        EquipmentList: [],
        EquipmentPropertiesList: [],
        FamilyTypes: [],
        DataSource: [],
        Buildings: [],
    },

    ReportDesigner: {
        reportDefinition: {
            id: -1,
            options: {
                name: "",
                desc: "",
                page: {
                    height: "11",
                    width: "8.5",
                    size: "letter",
                    orientation: "portrait",
                    widthUnit: "inch",
                    heightUnit: "inch",
                }
            },
            equations: [],
            widgets: []
        },
        dataStore: new Map(),
        saveStatus: null,

        dataSource:{
            datalogStore: {
                byFamType: new Map(),
                byObject: new Map(),
            },
            dataSourceType: 'datalog',
            datalog: {
                building: {list: null,selection: null},
                familytype: {list: null,selection: null},
                object: {list: null,selection: null},
                point: {list: null,selection: null, pointType: -1},
                datalog: {list: null,selection: null}
            },
            normalized: {
                building: {list: null,selection: null},
                familytype: {list: null,selection: null},
                object: {list: null,selection: null},
                point: {list: null,selection: null, pointType: -1},
                datalog: {list: null,selection: null}
            }
        },
    },

    //Facility Requests

    facilityRequests: {
        employee_MyRequests: [],
        employee_AllRequests: [],
    },

    // Dashboards

    Dashboards: {
        Current: {},
        ManageDashboardList: [],
    },
    ErrorStatus: "",
    HasApplicationFullAcess: true,
    HasWorkOrderAccess: 3,
    EquipmentSummaryDetail:[],

    //ASU Billing Invoices
    ASUBillingInvoices: {
        AllCampusInvoices: [],
        CampusMonthlyCharges: [],
        CampusBillingFilters: [],
        CampusSelectedBuildingInvoice: [],        
        BillingCalculations: []
    },
    WorkorderReportsDetails : [],

    // ScheduleReports
    ScheduleReports: {
        RecurrenceReportslist: [],
        EmailReceipentlist: {},
        ReportList:[],
        ReportId: ""
    },

    // Navigation:{
    //     RootNodes: [],
    //     ChildNodes: []
    // }
}